<template>
  <div class="warning p-4 my-4">
    {{ $t('general.errorMessage') }}
  </div>
</template>

<style scoped lang="scss">
.warning {
  background-color: var(--theme-font-color-accent-25);
  font-family: var(--font-medium);
  position: relative;
  height: auto;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
}
</style>
